export const styleForHeadding = "d-none";
export const hoverStyleForHeadding = "d-block bg-transparent fw-bolder";
export const hoverStyleForText = "d-block";
export const divStyleOnhover = "bg-warning opacity-50";

export const salarStarConstants = {
  title: "Salar Star Cricket Academy",
  description:
    "Next.js live landing page website with a content management system showcasing teams, players, events, and news. Built for optimal performance and SEO.",
};
export const goldenJasmineConstants = {
  title: "Golden Jasmine Management",
  description:
    "Full-stack management system for Saudi-based logistics company managing 20+ trucks. Features include Trip Management, Profit Calculation, Salary, Dues, Assets, Loans, and Expenses Management.",
};
export const fulrailConstants = {
  title: "Full Rail",
  description:
    "A comprehensive order management system with campaign tracking and analytics using React.js. Live and actively managing campaigns.",
};
export const surveyConstants = {
  title: "Feedback",
  description:
    "Live survey builder application with performance calculation and customer engagement features. Includes built-in inbox for email communication.",
};
export const ciwuw = {
  title: "CIWUW",
  description:
    "Call It What You Wanna (CIWUW): A full-featured e-commerce store and admin site with responsive design. Built with Next.js, currently serving live customers.",
};
export const jarvisConstants = {
  title: "Jarvis Testing Framework",
  description:
    "A comprehensive unit testing suite improving code quality and reliability across multiple live projects.",
};
export const bodyMapConstants = {
  title: "Body Map System",
  description:
    "An advanced analytics platform for fashion brands to understand tattoo placement preferences and optimize designs for tattooed consumers. Built with Next.js.",
};
